module.exports = __webpack_public_path__ + "static/media/tweet.aa0b53b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/tweet.png
// module id = 343
// module chunks = 0